module.exports = __webpack_public_path__ + "img/christmastree.e10d2a18.svg";